import { SortableItemHandle } from '../v2-common/SortableItemHandle';

/** Legacy "move vertically" icon wired as the drag handle of the enclosing SortableList item. */
export function MoveVerticallyHandle() {
  return (
    <SortableItemHandle ariaLabel="Reorder">
      <img src="/images/icon-move-vertically.svg" alt="" />
    </SortableItemHandle>
  );
}
